import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import { PROFILE_SLICE } from "./sliceNames";
import { ACCOUNT_DETAILS_INITIAL_VALUE } from "constants/initialValue";
import { IUpdateProfile } from "interfaces/account/accountProfile.interface";

const profileSlice = createSlice({
  name: PROFILE_SLICE,
  initialState: ACCOUNT_DETAILS_INITIAL_VALUE,
  reducers: {
    updateProfile: (state, action: PayloadAction<IUpdateProfile>) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { updateProfile } = profileSlice.actions;

export default profileSlice.reducer;
